import { AbstractBluetoothLowEnergyAdapter, BluetoothLowEnergyNamespace } from './AbstractBluetoothLowEnergyAdapter';

/**
 * Rejects every Bluetooth Low Energy operation on the Velocity browser.
 *
 * Velocity has no CandyCane bridge, and this capability is entirely bridge-backed — there is no
 * Velocity function to fall back to, as there is for printing. The rejection names the operation so a
 * tool running on a handheld gets a usable message rather than a bare failure.
 */
export class VelocityBluetoothLowEnergyAdapter extends AbstractBluetoothLowEnergyAdapter {
    public call(namespace: BluetoothLowEnergyNamespace, action: string, _parameters?: any): Promise<any> {
        return Promise.reject(new Error('Bluetooth Low Energy is not supported on Velocity browser: ' + namespace + '.' + action));
    }
}
